module.exports = __webpack_public_path__ + "fonts/Gilroy-Light.592ece9e.woff";